import React, {
  useCallback,
  useRef,
  useMemo,
  useState,
  Fragment,
  useEffect,
} from "react";
import * as Yup from "yup";
import { Form } from "@unform/web";
import api from "../../../services/api";
import { readDataStorage } from "../../../utils/storage/storage";
import { FormHandles } from "@unform/core";
import { Autocomplete } from "@mui/material";
import { TextField } from "unform-material-ui";
import Button from "@mui/material/Button";
import getValidationErrors from "../../../utils/getValidationErrors";
import { Input } from "../../Inputs/InputRef/";
import Toast from "../../Toast/Toast";
import errorIcon from "../../Toast/Image/error.svg";
import {
  DivForm,
  BigTitle,
  DivSelect,
  DivBoxInput,
  DivInput,
  GridSelect,
  DivButton,
  TextInfoThree,
} from "./styles";
import { writeStorage } from "../../../utils/storage/storage";
import { useProgress } from "../../../hooks/progress";
import ModalConsumoMinimo from "../../Modais/ModalConsumoMinimo";

const UserConsumption: React.FC = (props) => {
  const { setLoad } = useProgress();
  const [media, setMedia] = useState<number>(0);
  const [checkMedia, setCheckMedia] = useState<boolean>(false);
  const [modalIsOpen, setIsOpen] = useState(false);
  const { nome } = readDataStorage("filldata");
  const { idCard, estado, Concessionaria } = readDataStorage("home");

  const localStorageCard = readDataStorage("card");

  const [list, setList] = useState<any>([]);

  const showToast = useCallback(
    (type: any) => {
      let toastProperties: {
        id: number;
        title: string;
        description: string;
        backgroundColor: string;
        icon: any;
      } | null = null;

      const id = Math.floor(Math.random() * 101 + 1);
      switch (type) {
        case "error":
          toastProperties = {
            id,
            title: "",
            description: "Erro ao enviar dados",
            backgroundColor: "#D72828",
            icon: errorIcon,
          };
          break;

        default:
          setList([]);
      }

      setList([...list, toastProperties]);
    },
    [list]
  );

  const closeModal = () => {
    setIsOpen(false);
  };

  const classes = useMemo(
    () => [
      { value: "Monofásico", label: "Monofásico" },
      { value: "Bifásico", label: "Bifásico" },
      { value: "Trifásico", label: "Trifásico" },
    ],
    []
  );

  const gruposTarifarios = useMemo(
    () => [
      { value: "Residencial", label: "Residencial" },
      { value: "Comercial", label: "Comercial" },
      { value: "Industrial", label: "Industrial" },
      { value: "Rural", label: "Rural" },
      { value: "Outros", label: "Outros" },
    ],
    []
  );

  const meses = useMemo(
    () => [
      {
        id: "jan",
        label: "Jan",
        value: localStorageCard?.Jan > 0 ? localStorageCard?.Jan : 0,
      },
      {
        id: "fev",
        label: "Fev",
        value: localStorageCard?.Fev > 0 ? localStorageCard?.Fev : 0,
      },
      {
        id: "mar",
        label: "Mar",
        value: localStorageCard?.Mar > 0 ? localStorageCard?.Mar : 0,
      },
      {
        id: "abr",
        label: "Abr",
        value: localStorageCard?.Abr > 0 ? localStorageCard?.Abr : 0,
      },
      {
        id: "mai",
        label: "Mai",
        value: localStorageCard?.Mai > 0 ? localStorageCard?.Mai : 0,
      },
      {
        id: "jun",
        label: "Jun",
        value: localStorageCard?.Jun > 0 ? localStorageCard?.Jun : 0,
      },
      {
        id: "jul",
        label: "Jul",
        value: localStorageCard?.Jul > 0 ? localStorageCard?.Jul : 0,
      },
      {
        id: "ago",
        label: "Ago",
        value: localStorageCard?.Ago > 0 ? localStorageCard?.Ago : 0,
      },
      {
        id: "set",
        label: "Set",
        value: localStorageCard?.Set > 0 ? localStorageCard?.Set : 0,
      },
      {
        id: "out",
        label: "Out",
        value: localStorageCard?.Out > 0 ? localStorageCard?.Out : 0,
      },
      {
        id: "nov",
        label: "Nov",
        value: localStorageCard?.Nov > 0 ? localStorageCard?.Nov : 0,
      },
      {
        id: "dez",
        label: "Dez",
        value: localStorageCard?.Dez > 0 ? localStorageCard?.Dez : 0,
      },
    ],
    [
      localStorageCard?.Jan,
      localStorageCard?.Fev,
      localStorageCard?.Mar,
      localStorageCard?.Abr,
      localStorageCard?.Mai,
      localStorageCard?.Jun,
      localStorageCard?.Jul,
      localStorageCard?.Ago,
      localStorageCard?.Set,
      localStorageCard?.Out,
      localStorageCard?.Nov,
      localStorageCard?.Dez,
    ]
  );

  const useFormRef = useRef<FormHandles>(null);

  useEffect(() => {
    if (media <= 0) {
      if (localStorageCard?.MediaConsumo > 0) {
        setMedia(localStorageCard?.MediaConsumo);
      }
    }
  }, [media, setMedia, localStorageCard?.MediaConsumo]);

  const handleChangeValue = (e: any, name: string) => {
    let index = 0;
    let soma = 0;
    const { value } = e.target;

    useFormRef.current?.setFieldError(name, "");

    const limit = e.target.maxLength;
    console.log("onchange name: ", name);
    if (value.length === limit) {
      console.log("entrou: ", name);
      useFormRef.current?.setFieldError(name, "Limite atingido");
    }

    e.target.value = value.replace(/\D/g, "");

    const findIndex = meses.find(({ id }) => id === e.target.id);

    meses.forEach((elem) => {
      if (elem.id === findIndex?.id) {
        elem.value = value;
        writeStorage({
          key: "consumo",
          object: {
            meses: meses,
          },
        });
      }
      if (elem.value > 0) {
        soma += Math.trunc(elem.value);
        index++;
      }
      setMedia(Math.trunc(soma / index));

      if (soma > 0) {
        setCheckMedia(false);
      }
      return true;
    });
  };

  const handleNext = useCallback(() => {
    api.get("/csp/cliente/consultar/card/" + idCard).then((res: any) => {
      writeStorage({
        key: "card",
        object: {
          NomeTitularConta: res.data["empresa"],
          OndeEconomizar: res.data["onde_voc_quer_economizar"],
          Pessoa: res.data["tipo"],
          CNPJrepresentante: res.data["cnpj_do_representante_1"],
          Estado: res.data["estado"],
          Cidade: res.data["cidade"],
          Bairro: res.data["bairro"],
          Rua: res.data["rua"],
          Numero: res.data["n_mero"],
          Complemento: res.data["complemento"],
          Classe: res.data["classe"],
          Subclasse: res.data["subclasse"],
          Jan: res.data["jan"],
          Fev: res.data["fev"],
          Mar: res.data["mar"],
          Abr: res.data["abr"],
          Mai: res.data["mai"],
          Jun: res.data["jun"],
          Jul: res.data["jul"],
          Ago: res.data["ago"],
          Set: res.data["set"],
          Out: res.data["out"],
          Nov: res.data["nov"],
          Dez: res.data["dez"],
          MediaConsumo: res.data["m_dia_de_consumo"],
          FormaPagamento: res.data["forma_de_pagamento"],
          CEPvalidoCard: 1,
          RazaoSocialCard: res.data["raz_o_social"],
          Email: res.data["email"],
          EmailDoResponsavel: res.data["email_do_respons_vel_legal"],
          TelefoneTitularConta: res.data["telefone_do_titular_da_conta"],
          TelefoneResponsavelLegal: res.data["telefone_do_respons_vel_legal"],
          cpfCnpjCard:
            res.data["tipo"] === "PJ" ? res.data["cnpj"] : res.data["cpf"],
          DataNascimentoTitular: res.data["data_de_nascimento_do_titular"]
            ?.split(" ")[0]
            .split("/")
            .reverse()
            .join("-"),
          NomeResponsavelLegal: res.data["nome_do_respons_vel_legal"],
          CPF:
            res.data["tipo"] === "PF"
              ? res.data["cpf"]
              : res.data["cpf_do_respons_vel_legal"],
          CEP: res.data["cep"],
          NumeroInstalacao: res.data["n_mero_da_instala_o_cemig_1"],
          DataVencimentoFatura: res.data["data_de_vencimento_da_fatura_cemig"],
          Banco: res.data["banco"],
          CodBanco: res.data["codban"],
          Agencia: res.data["ag_ncia"],
          Conta: res.data["conta"],
          OptanteSimples: res.data["empresa_optante_pelo_simples"],
          Concessionaria: res.data["concession_ria"],
          TelefoneLigacao: res.data["telefone_contato_para_liga_o"],
        },
      });

      if (res.status === 200) {
        window.location.href = "/onboarding/step/2";
      }
    });
  }, [idCard]);

  const handleApiErrors = useCallback(
    (error: any, local: string) => {
      if (error.message === "Network Error") {
        if (!navigator.onLine) {
          showToast("error");
        }
      } else {
        showToast("error");
      }
    },
    [showToast]
  );

  const handleSubmitFormRegister = useCallback(
    async (data: any) => {
      try {
        setLoad(true);
        useFormRef.current?.setErrors({});
        data["average"] = media;
        const { classe, grupoTarifario } = data;
        const schema = Yup.object().shape({
          classe: Yup.string().required("Informe a Classe"),
          grupoTarifario: Yup.string().required("Informe o Grupo Tarifário"),
          average: Yup.number().positive(
            "Deve ser informado pelo menos um mês de consumo"
          ),
          jan: Yup.string().max(6, "Limite atingido"),
          fev: Yup.string().max(6, "Limite atingido"),
          mar: Yup.string().max(6, "Limite atingido"),
          abr: Yup.string().max(6, "Limite atingido"),
          mai: Yup.string().max(6, "Limite atingido"),
          jun: Yup.string().max(6, "Limite atingido"),
          jul: Yup.string().max(6, "Limite atingido"),
          ago: Yup.string().max(6, "Limite atingido"),
          set: Yup.string().max(6, "Limite atingido"),
          out: Yup.string().max(6, "Limite atingido"),
          nov: Yup.string().max(6, "Limite atingido"),
          dez: Yup.string().max(6, "Limite atingido"),
        });

        await schema.validate(data, {
          abortEarly: false,
        });
        await api
          .post("/csp/usuario/alterar/dadosFatura/", {
            idCard: idCard,
            classe: classe,
            estado: estado,
            concessionaria: Concessionaria,
            subClasse: grupoTarifario,
            consumoJan: meses[0].value,
            consumoFev: meses[1].value,
            consumoMar: meses[2].value,
            consumoAbr: meses[3].value,
            consumoMai: meses[4].value,
            consumoJun: meses[5].value,
            consumoJul: meses[6].value,
            consumoAgo: meses[7].value,
            consumoSet: meses[8].value,
            consumoOut: meses[9].value,
            consumoNov: meses[10].value,
            consumoDez: meses[11].value,
          })
          .then((res) => {
            if (res.data["proposta"] === 0) {
              setIsOpen(true);
            }
            if (res.data["proposta"] === 1) {
              writeStorage({
                key: "consumo",
                object: {
                  concessionaria: Concessionaria,
                  classe: classe,
                  subClasse: grupoTarifario,
                  consumoMinimo: res.data["consumoMinimo"],
                  arvoresCultivadas: res.data["arvoresCultivadas"],
                  carbonoEvitado: res.data["carbonoEvitado"],
                  economiaVerde: res.data["economiaVerde"],
                  economiaVerdeAno2: res.data["economiaVerdeAno2"],
                  economiaVerdeAno3: res.data["economiaVerdeAno3"],
                  economiaVerdeAno4: res.data["economiaVerdeAno4"],
                  economiaVerdeAno5: res.data["economiaVerdeAno5"],
                  economiaAmarela: res.data["economiaAmarela"],
                  economiaAmarelaAno2: res.data["economiaAmarelaAno2"],
                  economiaAmarelaAno3: res.data["economiaAmarelaAno3"],
                  economiaAmarelaAno4: res.data["economiaAmarelaAno4"],
                  economiaAmarelaAno5: res.data["economiaAmarelaAno5"],
                  economiaVermelhaI: res.data["economiaVermelhaI"],
                  economiaVermelhaIAno2: res.data["economiaVermelhaIAno2"],
                  economiaVermelhaIAno3: res.data["economiaVermelhaIAno3"],
                  economiaVermelhaIAno4: res.data["economiaVermelhaIAno4"],
                  economiaVermelhaIAno5: res.data["economiaVermelhaIAno5"],
                  economiaVermelhaII: res.data["economiaVermelhaII"],
                  economiaVermelhaIIAno2: res.data["economiaVermelhaIIAno2"],
                  economiaVermelhaIIAno3: res.data["economiaVermelhaIIAno3"],
                  economiaVermelhaIIAno4: res.data["economiaVermelhaIIAno4"],
                  economiaVermelhaIIAno5: res.data["economiaVermelhaIIAno5"],
                  economiaEscassez: res.data["economiaEscassez"],
                  economiaEscassezAno2: res.data["economiaEscassezAno2"],
                  economiaEscassezAno3: res.data["economiaEscassezAno3"],
                  economiaEscassezAno4: res.data["economiaEscassezAno4"],
                  economiaEscassezAno5: res.data["economiaEscassezAno5"],
                  kmCarroEletrico: res.data["kmCarroEletrico"],
                  mensalidade: res.data["mensalidade"],
                  economiaAnual: res.data["economiaAnual"],
                  mediaFinal: res.data["mediaFinal"],
                },
              });

              handleNext();
            }
          });
        setLoad(false);
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          useFormRef.current?.setErrors(errors);
          if (errors["average"]) {
            setCheckMedia(true);
          }
        } else {
          handleApiErrors(err, "Erro ao salvar registro");
        }
      }
      setLoad(false);
    },

    [
      handleApiErrors,
      meses,
      setCheckMedia,
      media,
      idCard,
      setLoad,
      estado,
      Concessionaria,
      handleNext,
    ]
  );

  return (
    <>
      <Toast toastList={list} autoDelete={true} />
      <Fragment>
        <ModalConsumoMinimo
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          recipient={nome}
        />
        <BigTitle>Informe seu consumo:</BigTitle>
        <DivForm>
          <Form
            ref={useFormRef}
            onSubmit={handleSubmitFormRegister}
            placeholder={undefined}
            onPointerEnterCapture={undefined}
            onPointerLeaveCapture={undefined}
          >
            <GridSelect>
              <DivSelect>
                <Autocomplete
                  sx={{ width: 310, height: 56, border: "none" }}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                  disablePortal
                  options={classes}
                  id="InputClasseOnb"
                  size="small"
                  defaultValue={localStorageCard?.Classe}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Classe"
                      name="classe"
                      variant="outlined"
                      defaultValue={localStorageCard?.Classe}
                    />
                  )}
                />
              </DivSelect>
              <DivSelect>
                <Autocomplete
                  sx={{ width: 310, height: 56, border: "none" }}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                  disablePortal
                  options={gruposTarifarios}
                  id="InputSubClasseOnb"
                  size="small"
                  defaultValue={localStorageCard?.Subclasse}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Grupo Tarifário"
                      name="grupoTarifario"
                      variant="outlined"
                      defaultValue={localStorageCard?.Subclasse}
                    />
                  )}
                />
              </DivSelect>
            </GridSelect>
            <TextInfoThree>
              Preencha o histórico de consumo em (kWh) dos últimos meses
              <span className="purple">*</span>:
            </TextInfoThree>

            <DivBoxInput>
              {meses.map((mes) => (
                <DivInput key={mes.id}>
                  <Input
                    name={mes.id}
                    label={mes.label}
                    type="text"
                    onChange={(e) => handleChangeValue(e, mes.id)}
                    defaultValue={
                      localStorageCard ? localStorageCard[mes.label] : ""
                    }
                    maxLength={6}
                  />
                </DivInput>
              ))}
            </DivBoxInput>

            <div
              className={`myClass ${checkMedia ? "activeSpan" : "disableSpan"}`}
            >
              Deve ser informado pelo menos um mês de consumo
            </div>

            <DivButton>
              <Button id="btnStep1Next" type="submit" className="buttonSend">
                Continuar
              </Button>
            </DivButton>
          </Form>
        </DivForm>
      </Fragment>
    </>
  );
};
export default UserConsumption;
